import modulePaths from 'constants/modulePath';
import moduleCodes from 'constants/moduleCodes';
import routePath from 'constants/routePath';
import { ReportsRouterHelper } from './helper/routerHelpers/reportsRouterHelper';
import { LearnerPortfolioRouterHelper } from './helper/routerHelpers/learnerPortfolioRouterHelper';
import { GeneralRouterHelper } from './helper/routerHelpers/generalRouterHelper';
import { ObservationsRouterHelper } from './helper/routerHelpers/observationsRouterHelper';
import { ParentShareRouterHelper } from './helper/routerHelpers/parentShareRouterHelper';
import { AssessmentRouterHelper } from './helper/routerHelpers/assessmentRouterHelper';

const modulePath = modulePaths[moduleCodes.MODULE_2BAP];

const getters = {
  
  getModuleUrl: () => `/${modulePath}`,
  
  getHomeUrl: () => `/${modulePath}/${routePath.ROUTE_2BAP_HOME}`,
  
  getReportListUrl: () => `/${modulePath}/${ReportsRouterHelper.REPORTS_LIST_PATH}`,
  
  getReportGenerationUrl: (reportType) =>
    `${getters._getReportGenerationBaseUrl()}?${ReportsRouterHelper.REPORTS_TYPE_IDENTIFIER}=${reportType}`,
  
  getLearnerPortfolioListUrl: () => `/${modulePath}/${LearnerPortfolioRouterHelper.LEARNER_PORTFOLIO_LIST_PATH}`,
  
  getAssessmentsUrl: () => `/${modulePath}/${AssessmentRouterHelper.ASSESSMENTS_PATH}`,
  
  getParentShareUrl: () => `/${modulePath}/${ParentShareRouterHelper.PARENT_SHARE_PATH}`,
  
  getMyProfileUrl: () => `/${modulePath}/${GeneralRouterHelper.MY_PROFILE_PATH}`,
  
  getLearnerPortfolioItemUrl: (learnerId) =>
    `/${modulePath}/${LearnerPortfolioRouterHelper.LEARNER_PORTFOLIO_LIST_PATH}/${learnerId}`,
  
  getObservationDetailsUrl: (observationId) =>
    `/${modulePath}/${ObservationsRouterHelper.OBSERVATION_DETAILS_PATH}/${observationId}`,
  
  // TODO: add proper 404 redirect and remove this
  getNotFoundPlaceholderUrl: () => GeneralRouterHelper.NOT_FOUND_PATH,
  
  _getReportGenerationBaseUrl: () => `/${modulePath}/${ReportsRouterHelper.REPORTS_GENERATION_PATH}`,
  
};

export default getters;
